import { render, staticRenderFns } from "./TiposAcuerdosGrid.vue?vue&type=template&id=82c22dce"
import script from "./TiposAcuerdosGrid.vue?vue&type=script&lang=js"
export * from "./TiposAcuerdosGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports